import { CustomSaasType } from "@/constants/customSaas";
import { z } from "zod";

export const SearchSchema = z.object({
  traceableSaasId: z.string().optional(),
});

export const ParamsSchema = z.object({
  customSaasType: z.nativeEnum(CustomSaasType),
});
